export default {
    ADD_MESSAGE: (state, message) => {
        state.messages.push(Object.assign({
            type: 'error',
            message: 'unknown',
            locale: true,
            show: true
        }, message))
    },

    REMOVE_MESSAGE: (state, messageId) => {
        state.messages = state.messages.filter(message => message.id != messageId)
    }
}
